import { AssistentItem } from '../assistent_config';
import { DateneingabeBetrieblicheDatenWeitereGewerke } from '../../DateneingabeBetrieblicheDatenWeitereGewerke';
import { getGewerkName, getWZobject } from '../../../../main/functions/getGewerk';
import { getWetterstation } from '../../functions/getWetterstation';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { WFormData } from '../../../../core/forms/WFormData';
import { validateFieldUniversal } from '../../functions/validateField';

let lastAdressString: string;
let tempFormData: any;

export function getAssistentConfigUnternehmen(dataGlobal: any, triggerService: TriggerService, customCfg?: AssistentItem): AssistentItem {
    const modulSelected: string = (dataGlobal || {}).MODUL_SELECTED;
    const config: any = require('../../../../wips.config.js');
    const untData = dataGlobal[IDs.ENT_UNTERNEHMENSDATEN];
    const unternehmen: any = (untData || [])[0] || {};
    let bereichKey = Array.isArray(untData) && untData.length > 0 ? untData[0].bereich_key_orig : null;
    const breiche = dataGlobal[IDs.ENT_BRANCHEN_BEREICHE];
    const breFnd = (breiche || []).find((r: any) => r.intern_key === bereichKey);
    let gewerk: number = Array.isArray(untData) && untData.length > 0 ? untData[0].gewerk_tid_orig : null;
    const privat_flag: boolean = bereichKey === 'privat';

    const wz = getWZobject(dataGlobal);
    const sit_count = wz ? (+wz.taetigkeit_kunden_bausstelle || 0) +
        (+wz.taetigkeit_ladengeschaeft || 0) +
        (+wz.taetigkeit_werkstatt_produktionsstaette || 0) : 0;
    const gewerkName = breFnd ? breFnd.name_gewerk : 'Gewerk';

    // Bitte so weit wie möglich in getCustomFormConfig.ts anpassen.
    const customFormConfig: any = {
        bereich_key: { hidden: true },
        gewerk_tid: { label: gewerkName, readonly: !bereichKey },
        ort_gtz: { hidden: true },
        betriebliche_situation: { hidden: sit_count !== 2 },
        ansprechpartner: { hidden: privat_flag },
        mitgliedsnummer: { hidden: bereichKey !== 'handwerk' },
        datei_logo: { hidden: privat_flag }
    };
    if (bereichKey === 'sonstige') {
        customFormConfig.wz_tid = {};
        customFormConfig.wz_tid.bundle_output = ['B:WZ 2008:', 'code_2008', 'bezeichnung_2008'];
    }

    const enableWeitereGewerke: boolean = config.devFeaturesMap && config.devFeaturesMap.N117_WEITERE_GEWERKE ? true : false;
    const showWeitereGewerke: boolean = enableWeitereGewerke && (unternehmen.bereich_key_orig || unternehmen.bereich_key) !== 'privat'
        && [147, 148].indexOf(+(unternehmen.gewerk_tid_orig || unternehmen.gewerk_tid)) === -1;

    const formGroupOrder = [
        {
            foldable: false,
            folded: false,
            fields: ['bereich_key', 'gewerk_tid', 'wz_tid', 'betriebliche_situation', 'name', 'rechtsform', 'hat_tochtergesellschaften', 'tochtergesellschaften', 'plz', 'ort']
        },
        {
            title: 'Optionale Daten',
            titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
            foldable: true,
            folded: true,
            fields: ['strasse', 'hausnummer', 'bundesland', 'ort_gtz', 'telefon', 'fax', 'email', 'mitgliedsnummer', 'ansprechpartner', 'datei_logo']
        }
    ];

    const eingabe_unternehmen: AssistentItem = {
        gliederung: '1.2',
        name: 'Unternehmensdaten',
        description: 'Dies ist das Formular zur Eingabe der Unternehmensdaten.',
        type: 'EntityForm',
        entity: IDs.ENT_UNTERNEHMENSDATEN,
        module: IDs.MOD_ETOOL,
        style: { marginLeft: '18px' },
        // disablePruefer: true,
        singleItem: true,
        configFlag: 'checkUnternehmen',
        customFormConfig,
        formGroupOrder,
        updateAssistentItem: (item: any) => {
            if (item.bereich_key !== bereichKey) {
                bereichKey = item.bereich_key;
                return getAssistentConfigUnternehmen(dataGlobal, triggerService);
            }
            if (item.gewerk_tid_orig !== gewerk) {
                gewerk = item.gewerk_tid_orig;
                return getAssistentConfigUnternehmen(dataGlobal, triggerService);
            }
        },
        bundleFilterFunc: (bundle: any, dat: any) => {
            // bundle.bereich_key = dat[IDs.ENT_BRANCHEN_BEREICHE];
            bundle.gewerk_tid = dat[IDs.ENT_BRANCHEN_GEWERKE].filter((r: any) => r.bereich_key_orig === bereichKey);;
            bundle.wz_tid = dat[IDs.ENT_GEWERKE_WZ];
            bundle.bundesland = dat[IDs.ENT_BUNDESLAND];
        },
        onFormChangeInteractive: async (formData: WFormData, onValueChange: (name: string, value: any) => void) => {
            tempFormData = formData.getAllValues();
            lastAdressString = await getWetterstation(dataGlobal, lastAdressString, formData, onValueChange);
        },
        externalDescriptionElement: (formData: any) => setCustomDescription(formData, gewerkName, modulSelected),
        callOnChangeRunIndex: () => onChangeRunIndex(gewerkName),
        customOnSaveDone: (entity: string, dataItem: any) => {
            triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN);
        },
        extraFormElementAfter: {
            wz_tid: showWeitereGewerke &&
                <DateneingabeBetrieblicheDatenWeitereGewerke
                    data={dataGlobal}
                />
        },
        ...(customCfg || {})
    };

    return eingabe_unternehmen;
}

function getInfo(key: string) {
    const msg: any = {
        gewerkErr1: 'Bitte ein Gewerk auswählen!',
        gewerkErr2: 'Sofern Ihre Tätigkeiten mehrere Gewerke umfassen, bitte das "Hauptgewerk" wählen.',
        plzErr1: 'Bitte eine gültige Postleitzahl eintragen!',
        plzErr2: 'Ohne diese Angabe kann die automatische Witterungsbereinigung für Wärmeverbräuche nicht berechnet werden. Mehr dazu erfahren Sie in der Auswertung der Wärmedaten.'
    }
    return msg[key];
}

function onChangeRunIndex(gewerkName: string) {
    if (tempFormData && tempFormData.tid > 0) {
        const blockText = getBlockText(tempFormData, gewerkName);
        if (blockText) {
            alert(blockText);
        }
    }
}

function getBlockText(formData: any, gewerkName: string) {
    const gewerkErr = gewerkName === 'Gewerk' && !(formData || {}).gewerk_tid;
    const plzErr = validateFieldUniversal(IDs.ENT_UNTERNEHMENSDATEN, 'plz', (formData || {}).plz, formData, () => { });
    const errMsg: Array<string> = [];
    if (gewerkErr) {
        errMsg.push(getInfo('gewerkErr1') + ' ' + getInfo('gewerkErr2'));
    }
    if (plzErr) {
        errMsg.push(getInfo('plzErr1') + ' ' + getInfo('plzErr2'));
    }
    if (errMsg.length > 0) {
        return errMsg.join("\n\n");
    }
    return null;
}

function setCustomDescription(formData: any, gewerkName: string, modulSelected: string) {
    const msgStyle: React.CSSProperties = { backgroundColor: '#fee', padding: 3, borderRadius: 5, textAlign: 'center', color: '#a77', border: '1px solid #faa' };
    const gewerErrkMsg = (
        <div style={{ ...msgStyle, marginBottom: 3 }}>
            {getInfo('gewerkErr1')}<br />
            <span style={{ fontSize: 12 }}>{getInfo('gewerkErr2')}</span>
        </div>
    );
    const plzErrkMsg = (
        <div style={{ ...msgStyle }}>
            {getInfo('plzErr1')}<br />
            <span style={{ fontSize: 12 }}>{getInfo('plzErr2')}</span>
        </div>
    );
    const errMsg: Array<JSX.Element> = [];
    const gewerkErr = gewerkName === 'Gewerk' && !(formData || {}).gewerk_tid;
    const plzErr = validateFieldUniversal(IDs.ENT_UNTERNEHMENSDATEN, 'plz', (formData || {}).plz, formData, () => { });
    if (gewerkErr) {
        errMsg.push(gewerErrkMsg);
    }
    if (plzErr && modulSelected !== 'steuer') {
        errMsg.push(plzErrkMsg);
    }
    if (errMsg.length > 0) {
        return <div>{errMsg}</div>;
    }
    return <div></div>;
}